import { render, staticRenderFns } from "./PSOPagination.vue?vue&type=template&id=3f5e2af5&scoped=true&"
import script from "./PSOPagination.vue?vue&type=script&lang=ts&"
export * from "./PSOPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e2af5",
  null
  
)

export default component.exports